module.exports = __webpack_public_path__ + "static/img/1设计师3.672475d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/1设计师3.png
// module id = kAaY
// module chunks = 1